import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { memo, useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const SHOW_BUTTON_THRESHOLD = 1250;

const BackToTop = () => {
    const { pathname } = useLocation();
    const checkoutPage = pathname.includes('/checkout/');
    const authSSORedirectPage = pathname.includes('/auth/google');
    const [showButton, setShowButton] = useState(false);
    const onScroll = useCallback(() => {
        if (window.scrollY >= SHOW_BUTTON_THRESHOLD && !showButton) {
            setShowButton(true);
        } else if (window.scrollY < SHOW_BUTTON_THRESHOLD && showButton) {
            setShowButton(false);
        }
    }, [showButton]);

    const handleClick = useCallback(() => {
        window.scrollTo({ behavior: 'smooth', top: 0 });
    }, []);

    useEffect(() => {
        if (window.scrollY) {
            onScroll();
        }

        window.addEventListener('scroll', onScroll);

        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, [onScroll]);

    if (checkoutPage || authSSORedirectPage) {
        return null;
    }

    return (
        <div
            className={`fixed right-[19px] bottom-[82px] z-[9] flex h-[44px] w-[44px] cursor-pointer flex-col items-center justify-center rounded-[40px] bg-surface-500 font-primary text-[10px] text-text-inverse print:hidden ${showButton ? 'visible' : 'invisible'} ${showButton ? 'opacity-100 transition-all duration-500 ease-in' : 'opacity-0'}`}
            onClick={handleClick}
        >
            <div className="items-centerx border-b-white mt-[7px] mb-[5px] h-0 w-0 justify-center border-r-8 border-b-8 border-l-8 border-r-transparent border-l-transparent" />
            <div className="mb-[7px] text-center leading-[13px]">
                <FormattedMessage id="back_to_top_button" />
            </div>
        </div>
    );
};

export default memo(BackToTop);
